var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cardProgress',{attrs:{"options":{
    ..._vm.options,
    info: _vm.info,
    total: _vm.total,
    confirmed: _vm.confirmed,
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }